import Request from '@/api/request';

/**
 * @description: user login api
 */

export const getPlacements = async (params, start = 0, limit = 100) => {
  const requestParams = {
    ...params,
    sort: {
      'ranking' : -1,
      // 'id'      : -1,
    },
    pagination: {
      'start' : start,
      'limit' : limit,
    }
  };
  return await Request.get('/v1/placements', requestParams).then((res) => {
    return res;
  });
};

export const getPlacement = async (id) => {
  let params = {};
  return await Request.get('/v1/placements/' + id, params).then((res) => {
    return res;
  });
};

export const postPlacement = async (params) => {
  let uri = '/v1/placements';
  return await Request.formpost(uri, params).then((res) => {
    return res;
  });
}

export const putPlacement = async (placementid, params) => {
  return await Request.put('/v1/placements/'+placementid, params).then((res) => {
      return res;
  });
}

export const putPlacementOnline = async (placementid) => {
  return await Request.put('/v1/placements/'+placementid+'/online', {}).then((res) => {
      return res;
  });
}

export const putPlacementOffline = async (placementid) => {
  return await Request.put('/v1/placements/'+placementid+'/offline', {}).then((res) => {
      return res;
  });
}


export const clickPlacement =  (placementid, params) => {
  return Request.getUrl('/v1/placements/'+placementid+'/click', params)
}

export const getAds = async (placementid, params, start = 0, limit = 100) => {
  const requestParams = {
    ...params,
    sort: {
      'ranking' : -1,
      // 'id'      : -1,
    },
    pagination: {
      'start' : start,
      'limit' : limit,
    }
  };
  return await Request.get('/v1/placements/'+placementid+'/ad', requestParams).then((res) => {
    return res;
  });
};

export const getAd = async (placementid, id) => {
  let params = {};
  return await Request.get('/v1/placements/'+placementid+'/ads/' + id, params).then((res) => {
    return res;
  });
}

export const postAd = async (placementid, file, params) => {
  return await Request.fileformpost('/v1/placements/'+placementid+'/ads', 'filecover', file, params).then((res) => {
      return res;
  });
}

export const postAdCover = async (placementid, id, filecover) => {
  let uri = '/v1/placements/'+placementid+'/ads/'+id+'/cover';
  return await Request.fileformpost(uri, 'filecover', filecover).then((res) => {
      return res;
  });
}

export const putAd = async (placementid, id, params) => {
  return await Request.put('/v1/placements/'+placementid+'/ads/'+id, params).then((res) => {
      return res;
  });
}

export const putAdOnline = async (placementid, id) => {
  return await Request.put('/v1/placements/'+placementid+'/ads/'+id + '/online', {}).then((res) => {
      return res;
  });
}

export const putAdOffline = async (placementid, id) => {
  return await Request.put('/v1/placements/'+placementid+'/ads/'+id + '/offline', {}).then((res) => {
      return res;
  });
}

export const deleteAd = async (placementid, id) => {
  return await Request.delete('/v1/placements/'+placementid+'/ads/'+id, {}).then((res) => {
      return res;
  });
}